// The shape of a sound file for drawing: `bars` peaks from 0 to 1, loudest at 1, and its length in
// seconds. Decoded in an OfflineAudioContext, which never opens the output device, so drawing a
// waveform cannot crackle in headphones the way a live AudioContext can (see matchmakingSounds.js).
const cache = {}; // by src and bars: a promise of { peaks, duration }, or of null when undrawable

function measure(buffer, bars) {
  const data = buffer.getChannelData(0);
  const size = Math.max(1, Math.floor(data.length / bars));
  const peaks = Array.from({ length: bars }, (_, bar) => {
    let peak = 0;
    for (let i = bar * size; i < Math.min(data.length, (bar + 1) * size); i += 1) {
      peak = Math.max(peak, Math.abs(data[i]));
    }
    return peak;
  });
  const loudest = Math.max(...peaks) || 1;
  return { peaks: peaks.map((peak) => peak / loudest), duration: buffer.duration };
}

export default function waveformPeaks(src, bars) {
  const key = `${src}#${bars}`;
  if (!cache[key]) {
    const Offline = window.OfflineAudioContext || window.webkitOfflineAudioContext;
    cache[key] = !Offline ? Promise.resolve(null) : fetch(src)
      .then((response) => {
        if (!response.ok) throw new Error(`${src}: ${response.status}`);
        return response.arrayBuffer();
      })
      .then((bytes) => new Offline(1, 1, 44100).decodeAudioData(bytes))
      .then((buffer) => measure(buffer, bars))
      .catch(() => {
        delete cache[key];
        return null;
      });
  }
  return cache[key];
}
